import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "numerics-list" }

import VWidget from '../components/VWidget.vue';
import VWidgetHeader from '../components/VWidgetHeader.vue';

import VNumericCard from '../components/VNumericCard.vue';

// Other
import { PropType, ref, toRef, watch } from 'vue';
import NumericsService from '@/core/Services/NumericService';
import INumeric from '@/core/Models/INumeric';
import { $error } from '@/utils/app-utils';
import IQueryNumericRequest from '@/core/Requests/IQueryNumericRequest';
import { useNumericMutator } from '@/mixins/NumericApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumericsWidget',
  props: {
    filters: { type: Object as PropType<IQueryNumericRequest>, default: () => ({}) },

    title: { type: String, default: '' },

    widgetPage: { type: Boolean, default: false },
    widgetSpace: { type: Boolean, default: false },
    widgetPrimary: { type: Boolean, default: false },
    widgetSecondary: { type: Boolean, default: false },
},
  setup(__props) {

// Components
const props = __props;

let filters = toRef(props, 'filters');
let numerics = ref([] as INumeric[]);

const { trackMutations } = useNumericMutator(null, filters);

watch(filters, fetchNumerics, { immediate: true });

async function fetchNumerics() {
    try {
        numerics.value = await NumericsService.queryAsync(filters.value);
        trackMutations(numerics.value);
    } catch (error) {
        $error(error);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(VWidget, {
    class: "my-numerics-widget",
    page: props.widgetPage,
    primary: props.widgetPrimary,
    secondary: props.widgetSecondary,
    space: props.widgetSpace
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(VWidgetHeader, { title: __props.title }, null, 8, ["title"]), [
        [_vShow, __props.title]
      ]),
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numerics), (goal) => {
          return (_openBlock(), _createElementBlock("li", {
            key: goal.id,
            class: "numerics-list__item"
          }, [
            _createVNode(_component_RouterLink, {
              class: "prevent-close numeric-goal-selector",
              "numeric-id": goal.id,
              to: { query: { numeric: goal.id } }
            }, {
              default: _withCtx(() => [
                _createVNode(VNumericCard, { goal: goal }, null, 8, ["goal"])
              ]),
              _: 2
            }, 1032, ["numeric-id", "to"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["page", "primary", "secondary", "space"]))
}
}

})